import React from "react";
import Box from "@material-ui/core/Box";

import { StatButtons } from "./StatButtons";
import { Editor } from "./Editor";
import { ITeam } from "apis";

interface IDataEditorProps {
  homeTeam?: ITeam;
  awayTeam?: ITeam;
}

export const DataEditor = ({ homeTeam, awayTeam }: IDataEditorProps) => {
  return (
    <>
      <StatButtons />
      <Box mt={1} />
      <Editor homeTeam={homeTeam} awayTeam={awayTeam} />
    </>
  );
};
